import "./H4.scss"

export const H4 = ({
  children = null,
  className = "",
  testid = "H4",
  ...rest
}) => (
  <div
    className={`H4 maax-font-weight-regular ${className}`}
    style={{
      color: `#4f4f58`,
    }}
    data-testid={testid}
    {...rest}
  >
    {children}
  </div>
)

// Note: React 19 no-longer supports propTypes. Leaving this for reference.
// H4.propTypes = {
//   children: PropTypes.node,
//   className: PropTypes.string,
//   testid: PropTypes.string,
// }

// Note: React 19 no-longer supports defaultProps. Leaving this for reference.
// H4.defaultProps = {
//   children: null,
//   className: "",
//   testid: "H4",
// }
